import {
    GET_TEMPLATE,
    GET_TEMPLATE_SUCCESS,
    GET_TEMPLATE_FAIL,
    SAVE_TEMPLATE,
    RESET_MESSAGE,
    SAVE_TEMPLATE_SUCCESS,
    SAVE_TEMPLATE_FAIL,
    GET_REPORT,
    GET_REPORT_SUCCESS,
    GET_REPORT_FAIL,
    GET_DRAFT_REPORT,
    GET_DRAFT_REPORT_SUCCESS,
    GET_DRAFT_REPORT_FAIL,
    SAVE_REPORT,
    SAVE_REPORT_SUCCESS,
    SAVE_REPORT_FAIL,
    UPDATE_REPORT,
    UPDATE_REPORT_SUCCESS,
    UPDATE_REPORT_FAIL,
    DELETE_REPORT,
    DELETE_REPORT_SUCCESS,
    DELETE_REPORT_FAIL,
    PUBLISH_DRAFT,
    PUBLISH_DRAFT_SUCCESS,
    PUBLISH_DRAFT_FAIL
} from "./actionTypes"

const INIT_STATE = {
    loadingTemplate: false,
    savingTemplate: false,
    template: {},
    savingTemplateMsg: false,
    loadingTemplateErr: false,
    savingTemplateErr: false,

    loadingDraft: false,
    draftReports: [],
    loadingDraftErr: false,

    loadingReport: false,
    savingReport: false,
    deletingReport: false,
    report: {},
    loadingReportErr: false,
    savingReportErr: false,
    deletingReportErr: false,
    savingReportMsg: false,
    deletingReportMsg: false,
}

const OperationalReport = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TEMPLATE:
            return {
                ...state,
                loadingTemplate: true,
                template: {},
                loadingTemplateErr: false,
            }
        case GET_TEMPLATE_SUCCESS:
            return {
                ...state,
                loadingTemplate: false,
                template: action.payload,
                loadingTemplateErr: false
            }
        case GET_TEMPLATE_FAIL:
            return {
                ...state,
                loadingTemplate: false,
                template: {},
                loadingTemplateErr: action.payload
            }
        case SAVE_TEMPLATE:
            return {
                ...state,
                savingTemplate: true,
                savingTemplateMsg: false,
                savingTemplateErr: false
            }
        case SAVE_TEMPLATE_SUCCESS:
            return {
                ...state,
                savingTemplate: false,
                savingTemplateMsg: action.payload,
                savingTemplateErr: false
            }
        case SAVE_TEMPLATE_FAIL:
            return {
                ...state,
                savingTemplate: false,
                savingTemplateMsg: false,
                savingTemplateErr: action.payload
            }
        case GET_REPORT:
            return {
                ...state,
                loadingReport: true,
                report: {},
                loadingReportErr: false
            }
        case GET_REPORT_SUCCESS:
            return {
                ...state,
                loadingReport: false,
                report: action.payload,
                loadingReportErr: false,
            }
        case GET_REPORT_FAIL:
            return {
                ...state,
                loadingReport: false,
                report: {},
                loadingReportErr: action.payload,
            }
        case SAVE_REPORT:
            return  {
                ...state,
                savingReport: true,
                savingReportMsg: false,
                savingReportErr: false
            }
        case SAVE_REPORT_SUCCESS:
            return  {
                ...state,
                savingReport: false,
                savingReportMsg: action.payload,
                savingReportErr: false
            }
        case SAVE_REPORT_FAIL:
            return  {
                ...state,
                savingReport: false,
                savingReportMsg: false,
                savingReportErr: action.payload
            }
        case UPDATE_REPORT:
            return  {
                ...state,
                savingReport: true,
                savingReportMsg: false,
                savingReportErr: false
            }
        case UPDATE_REPORT_SUCCESS:
            return  {
                ...state,
                savingReport: false,
                savingReportMsg: action.payload,
                savingReportErr: false
            }
        case UPDATE_REPORT_FAIL:
            return  {
                ...state,
                savingReport: false,
                savingReportMsg: false,
                savingReportErr: action.payload
            }
        case DELETE_REPORT:
            return  {
                ...state,
                deletingReport: true,
                deletingReportMsg: false,
                deletingReportErr: false
            }
        case DELETE_REPORT_SUCCESS:
            return  {
                ...state,
                deletingReport: false,
                deletingReportMsg: 'Report deleted successfully',
                draftReports: action.payload,
                deletingReportErr: false
            }
        case DELETE_REPORT_FAIL:
            return  {
                ...state,
                deletingReport: false,
                deletingReportMsg: false,
                deletingReportErr: action.payload
            }
        case GET_DRAFT_REPORT:
            return {
                ...state,
                loadingDraft: true,
                draftReports: [],
                loadingDraftErr: false
            }
        case GET_DRAFT_REPORT_SUCCESS:
            return {
                ...state,
                loadingDraft: false,
                draftReports: action.payload,
                loadingDraftErr: false
            }
        case GET_DRAFT_REPORT_FAIL:
            return {
                ...state,
                loadingDraft: false,
                draftReports: [],
                loadingDraftErr: action.payload
            }
        case RESET_MESSAGE:
            return {
                ...state,
                savingTemplateMsg: false,
                loadingTemplateErr: false,
                savingTemplateErr: false,
                loadingDraftErr: false,
                loadingReportErr: false,
                savingReportErr: false,
                deletingReportErr: false,
                savingReportMsg: false,
                deletingReportMsg: false,
            }
        case PUBLISH_DRAFT:
            return {
                ...state,
                loadingDraft: true,
                loadingDraftErr: false,
            }
        case PUBLISH_DRAFT_SUCCESS:
            return {
                ...state,
                loadingDraft: false,
                draftReports: action.payload,
                loadingDraftErr: false,
            }
        case PUBLISH_DRAFT_FAIL:
            return {
                ...state,
                loadingDraft: false,
                loadingDraftErr: action.payload,
            }
        default:
            return state
    }
}
export default OperationalReport